import { z } from 'zod';
import { patchOf } from './patch';

export const templateTask = z.object({
  title: z.string().trim().min(1).max(200),
  /** Dias depois do início do projeto para o prazo (vazio = sem prazo). */
  offsetDays: z.number().int().min(0).max(730).nullable().default(null),
  serviceTypeId: z.uuid().nullable().default(null),
  quantity: z.number().int().min(1).max(1000).default(1),
});

export const templateInput = z.object({
  name: z.string().trim().min(1, 'Dê um nome').max(120),
  description: z
    .string()
    .trim()
    .max(1000)
    .optional()
    .transform((v) => v || null),
  tasks: z.array(templateTask).min(1, 'Inclua ao menos uma etapa').max(200),
});
export type TemplateInput = z.input<typeof templateInput>;
export const templatePatch = patchOf(templateInput);

export const templateDto = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullable(),
  tasks: z.array(
    z.object({
      title: z.string(),
      offsetDays: z.number().nullable(),
      serviceTypeId: z.uuid().nullable(),
      quantity: z.number(),
    }),
  ),
  createdAt: z.string(),
});
export type TemplateDto = z.infer<typeof templateDto>;

export const applyTemplateInput = z.object({
  projectId: z.uuid(),
  /** Data base para os prazos (padrão: início do projeto ou hoje). */
  startDate: z.iso.date().optional(),
});
